import { Data } from 'signup-constants/signupData/Data';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { getDomainFromEmail } from '../utils/getDomainFromEmail';
import { getIsFreemailDomain } from '../utils/getIsFreemailDomain';
export const getGTKMDomainToUse = state => {
  const email = getSignupDataValue(state, Data.Email);
  const companyDomain = getSignupDataValue(state, Data.CompanyDomain);
  const domainFromEmail = getDomainFromEmail(email);
  const domain = companyDomain || domainFromEmail;
  return domain === 'hubspot.com' ? 'hubspot-test.com' : domain;
};
export const getGTKMFallbackDomain = state => {
  const domain = getGTKMDomainToUse(state);
  const isFreemailDomain = getIsFreemailDomain(domain);
  return isFreemailDomain ? '' : domain;
};